import { render, staticRenderFns } from "./ContentsMurdoch.vue?vue&type=template&id=0e97b726&"
import script from "./ContentsMurdoch.vue?vue&type=script&lang=js&"
export * from "./ContentsMurdoch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports